import * as requestFromServer from "./ActivityReportCrud";
import { callTypes, activityReportSlice } from "./ActivityReportSlice";

const {actions} = activityReportSlice;

export const getActivityReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.list }));  
  return requestFromServer
    .getActivityReport(queryParams)
    .then(response => {
      dispatch(actions.activityReportFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getAllActivityReport = queryParams => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getAllActivityReport(queryParams)
    .then(response => {
      dispatch(actions.actionCompleted());
      return response.data;
    })
    .catch(error => {
      
    });
};

export const getList = () => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getList()
    .then(response => {
      dispatch(actions.listFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getTeachers = term => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getTeachers(term)
    .then(response => {
      dispatch(actions.teachersFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const getStudents = (term, sectionId) => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));  
  return requestFromServer
    .getStudents(term, sectionId)
    .then(response => {
      dispatch(actions.studentsFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const downloadAttachment = id => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
  .downloadAttachment(id)
  .then(response => {
    dispatch(actions.actionCompleted());
    return response.data;
  })
  .catch(error => {
    dispatch(actions.actionCompleted());
  });
};

export const getExplanation = activityId => async dispatch => {
  dispatch(actions.startCall({ callType: callTypes.action }));
  return requestFromServer
    .getExplanation(activityId)
    .then(response => {
      dispatch(actions.explanationFetched(response.data));
    })
    .catch(error => {
      
    });
};

export const cleanExplanation = () => dispatch => {
  dispatch(actions.explanationCleaned());
}

export const cleanStudentsState = () => dispatch => {
  dispatch(actions.studentsStateCleaned());
}

export const cleanActivitiesState = () => dispatch => {
  dispatch(actions.activitiesStateCleaned());
}